import { createContext, useContext } from 'react'
import type { AuthenticatedUser } from '@/contexts/AuthContext.tsx'
import type { Permission } from '@/types/permission.types.ts'

export type AuthenticatedAuthState = {
  status: 'AUTHENTICATED'
  user: AuthenticatedUser
  logout: (errorCode?: string) => Promise<void>
  getGlobalToken: () => Promise<string>
  hasPermissions: (permissions: Permission[]) => boolean
  rejectIfMissingPermissions: (requiredPermissions: Permission[]) => void
}

export type PendingAuthState = {
  status: 'PENDING'
  loader: () => Promise<AuthenticatedAuthState>
}

export type AnonymousAuthState = {
  status: 'ANONYMOUS'
  login: (username: string, password: string) => Promise<void>
  errorCode?: string
}

export type AuthState = AuthenticatedAuthState | PendingAuthState | AnonymousAuthState

export const AuthContext = createContext<AuthState | undefined>(undefined)

export function useAuth() {
  const context = useContext(AuthContext)
  if (context === undefined) {
    throw new Error('useAuth must be used within an AuthProvider')
  }
  return context
}
